import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const firebaseConfig2 = {
  apiKey: process.env.REACT_APP_API_KEY_PUBLIC,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN_PUBLIC,
  projectId: process.env.REACT_APP_PROJECT_ID_PUBLIC,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET_PUBLIC,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID_PUBLIC,
  appId: process.env.REACT_APP_APP_ID_PUBLIC,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID_PUBLIC,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const publicApp = initializeApp(firebaseConfig2, "Public_App");
export const authenticate = getAuth(app);
export const storage = getStorage(app);
export const publicStorage = getStorage(publicApp);
